import React from 'react'
import { Pagination } from 'react-bootstrap'
import Page from './page'

const EightPlusPagination = ({
    totalPages,
    currentPage,
    setCurrentPage
}) => {
    
    let middlePages = [3, 4, 5]
    if (currentPage >=5) {
        middlePages = [currentPage - 1, currentPage, currentPage + 1]
    }
    if (currentPage >= totalPages - 2) {
        middlePages = [totalPages - 4, totalPages - 3, totalPages - 2]
    }
    return (
        <Pagination className='justify-content-center'>
            <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
            <Page page={1} currentPage={currentPage} onSetPage={setCurrentPage} />

            { currentPage >= 5 && <Pagination.Ellipsis /> }
            { currentPage < 5 && <Page page={2} currentPage={currentPage} onSetPage={setCurrentPage} /> }

            {middlePages.map((page, key) => <Page key={key} page={page} currentPage={currentPage} onSetPage={setCurrentPage} />)}

            { currentPage <= totalPages - 3 && <Pagination.Ellipsis /> }
            { currentPage > totalPages - 3 && <Page page={totalPages - 1} currentPage={currentPage} onSetPage={setCurrentPage} /> }

            <Page page={totalPages} currentPage={currentPage} onSetPage={setCurrentPage} />
            <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
        </Pagination>
    )
}

export default EightPlusPagination